import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/ai";

export const aiAssistantApi = {
  getCapabilities: () => apiGet<{ data: Record<string, unknown>[] }>(`${BASE}/capabilities`),

  createConversation: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/conversations`, body),

  listConversations: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/conversations?${searchParams.toString()}`);
  },

  getConversation: (id: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<{ data: Record<string, unknown> }>(`${BASE}/conversations/${id}?${searchParams.toString()}`);
  },

  sendMessage: (id: string, content: string) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/conversations/${id}/messages`, { content }),

  clearConversation: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`${BASE}/conversations/${id}`),

  rateMessage: (id: string, messageId: string, rating: number) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/conversations/${id}/messages/${messageId}/rate`, { rating }),

  getUsage: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/usage`),

  bulkDeleteConversations: (ids: string[]) => apiDelete<{ data: number }>(`${BASE}/conversations/bulk-delete`, { data: { ids } }),

  getUsageStats: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/usage/stats`),

  exportUsage: (format = "CSV") => apiGet<{ data: unknown }>(`${BASE}/usage/export?format=${format}`),
};